import { ComponentProps, ComponentType, useState } from "react";
import { styled } from "~/application/theme";
import { DefaultCompanyLogo } from "~/presentation/shared/components/DefaultCompanyLogo";
import { Image } from "../Image";

export interface CompanyLogoProps extends ComponentProps<typeof StyledImage> {
  fallbackIcon?: ComponentType;
}

const StyledImage = styled(Image, {
  variants: {
    size: {
      sm: {
        height: "$4",
      },
      md: {
        height: "$6",
      },
      lg: {
        height: "$8",
      },
      "2xl": {
        height: "$12",
      },
      "3xl": {
        height: "$16",
      },
      "4xl": {
        height: "$18",
      },
    },
  },
  defaultVariants: {
    size: "lg",
  },
});

export function CompanyLogo({
  src,
  alt = "Logo da companhia",
  fallbackIcon,
  onError,
  ...props
}: CompanyLogoProps) {
  const [failedSrc, setFailedSrc] = useState<string>();

  if ((!src || src === failedSrc) && fallbackIcon) {
    return <DefaultCompanyLogo icon={fallbackIcon} companyName={alt} />;
  }

  return (
    <StyledImage
      src={src}
      alt={alt}
      onError={(e) => {
        if (typeof src === "string") {
          setFailedSrc(src);
        }
        onError?.(e);
      }}
      {...props}
    />
  );
}
